import React, { useState } from 'react'
import {
  Container, Nav, NavItem, NavLink,
} from 'reactstrap'
import classnames from 'classnames'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import ModelosTab from './ModelosTab'
import CatalogoTab from './CatalogoTab'
import './gestaoMinutas.css'

const TAB_MODELOS = 'modelos'
const TAB_CATALOGO = 'catalogo'

const GestaoMinutas = () => {
  const [activeTab, setActiveTab] = useState(TAB_MODELOS)

  return (
    <div className="page-content minuta-page">
      <Container fluid>
        <Breadcrumbs title="Gestão de Minutas" breadcrumbItems={[]} />

        <Nav tabs className="mb-3">
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === TAB_MODELOS })}
              onClick={() => setActiveTab(TAB_MODELOS)}
            >
              Modelos de Minuta
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === TAB_CATALOGO })}
              onClick={() => setActiveTab(TAB_CATALOGO)}
            >
              Cláusulas e Seções
            </NavLink>
          </NavItem>
        </Nav>

        {activeTab === TAB_MODELOS && <ModelosTab />}
        {activeTab === TAB_CATALOGO && <CatalogoTab />}
      </Container>
    </div>
  )
}

export default GestaoMinutas
